import React, { useEffect, useState } from "react";

import { Button, Modal, Row, Space } from "antd";
import { ColumnsType } from "antd/lib/table";
import { useAsyncAxios, utilAxiosWithAuth } from "../utils/customAxios";

import * as Request from "../commons/request";
import * as Types from "../commons/typeDTO";
import * as String from "../commons/string";
import * as Common from "../commons/common";
import * as Utils from "../utils/utils";

import DataTable from "../components/DataTable";
import ModalCoupon from "../components/ModalCoupon";
import ModalAssignCoupon from "../components/ModalAssignCoupon";
import moment from "moment";

function CouponManagement() {
    const [coupons, setCoupons] = useState<Array<Types.CouponDto>>([]);
    const [disabledCoupons, setDisabledCoupons] = useState<Array<number>>([]);
    const [currentCoupon, setCurrentCoupon] = useState<Types.CouponDto>();

    const [openModalCoupon, setOpenModalCoupon] = useState(false);
    const [openModalAssignCoupon, setOpenModalAssignCoupon] = useState(false);

    const columns: ColumnsType<Types.CouponDto> = [
        {
            align: "center",
            title: "순서",
            dataIndex: "couponOrder",
            key: "couponOrder",
        },
        {
            align: "center",
            title: "적용대상",
            dataIndex: "couponCoverage",
            key: "couponCoverage",
            sorter: (a, b, sortOrder) => Utils.sortString(a.couponCoverage.valueOf(), b.couponCoverage.valueOf(), sortOrder),
            render: (_, row) => (row.couponCoverage === "ORDER" ? "구매" : row.couponCoverage === "RENT" ? "렌트" : "B2B"),
        },
        {
            align: "center",
            title: "사용분류",
            dataIndex: "multiCoupon",
            key: "multiCoupon",
            sorter: (a, b, sortOrder) => Utils.sortString(a.multiCoupon.toString().valueOf(), b.multiCoupon.toString().valueOf(), sortOrder),
            render: (_, row) => (row.multiCoupon ? "중복" : "단독"),
        },
        {
            align: "center",
            title: "쿠폰명",
            dataIndex: "couponName",
            key: "couponName",
        },
        {
            align: "center",
            title: "쿠폰 사용 시작일",
            dataIndex: "effectiveDate",
            key: "effectiveDate",
            sorter: (a, b, sortOrder) => Utils.sortString(a.effectiveDate.toString().valueOf(), b.effectiveDate.toString().valueOf(), sortOrder),
            render: (_, row) => row.effectiveDate.substring(0, 10),
        },
        {
            align: "center",
            title: "쿠폰 사용 만료일",
            dataIndex: "expiredDate",
            key: "expiredDate",
            sorter: (a, b, sortOrder) => Utils.sortString(a.expiredDate.toString().valueOf(), b.expiredDate.toString().valueOf(), sortOrder),
            render: (_, row) => row.expiredDate.substring(0, 10),
        },
        {
            align: "center",
            title: "상태",
            dataIndex: "status",
            key: "status",
            sorter: (a, b, sortOrder) =>
                Utils.sortString(
                    (a.expiredDate < moment().format(Common.FORMAT_DATE_TIME) ? "기간 만료" : "사용 가능").valueOf(),
                    (b.expiredDate < moment().format(Common.FORMAT_DATE_TIME) ? "기간 만료" : "사용 가능").valueOf(),
                    sortOrder
                ),
            render: (_, row) => (row.expiredDate < moment().format(Common.FORMAT_DATE_TIME) ? "기간 만료" : "사용 가능"),
        },
        {
            align: "center",
            title: "발행수",
            dataIndex: "publishedCount",
            key: "publishedCount",
            sorter: (a, b, sortOrder) => Utils.sortString(a.publishedCount.toString().valueOf(), b.publishedCount.toString().valueOf(), sortOrder),
        },
        {
            align: "center",
            title: "할당수",
            dataIndex: "assignCount",
            key: "assignCount",
            sorter: (a, b, sortOrder) => Utils.sortString(a.assignCount.toString().valueOf(), b.assignCount.toString().valueOf(), sortOrder),
        },
        {
            align: "center",
            title: "미사용수",
            dataIndex: "unusedCount",
            key: "unusedCount",
            sorter: (a, b, sortOrder) => Utils.sortString(a.unusedCount.toString().valueOf(), b.unusedCount.toString().valueOf(), sortOrder),
        },
        {
            align: "center",
            title: " ",
            render: (_, row) => {
                return (
                    <>
                        {row.expiredDate >= moment().format(Common.FORMAT_DATE_TIME) && (
                            <Button
                                shape="round"
                                size="small"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    onAssignCoupon(row);
                                }}
                            >
                                할당
                            </Button>
                        )}
                        <Button
                            shape="round"
                            size="small"
                            onClick={(e) => {
                                e.stopPropagation();
                                onUpdateCoupon(row);
                            }}
                        >
                            수정
                        </Button>
                        <Button
                            shape="round"
                            size="small"
                            onClick={(e) => {
                                e.stopPropagation();
                                onDeleteCoupon(row);
                            }}
                        >
                            삭제
                        </Button>
                    </>
                );
            },
        },
    ];

    useEffect(() => {
        requestGetCoupons();
    }, []);

    //get coupons
    const requestAxiosGetCoupons = async () => {
        const response = await utilAxiosWithAuth().get(Request.COUPONS_URL);
        return response.data;
    };

    const { loading: loadingGetCoupons, error: errorGetCoupons, data: resultGetCoupons, execute: requestGetCoupons } = useAsyncAxios(requestAxiosGetCoupons);

    useEffect(() => {
        if (resultGetCoupons === null) return;
        console.log("resultGetCoupons", resultGetCoupons);

        setCoupons(resultGetCoupons.coupons);

        const disabledCoupon = resultGetCoupons.coupons.filter((coupon: Types.CouponDto) => coupon.expiredDate < moment().format(Common.FORMAT_DATE_TIME));
        if (disabledCoupon.length > 0) {
            setDisabledCoupons(disabledCoupon.map((coupon: Types.CouponDto) => coupon.couponId));
        }
    }, [resultGetCoupons]);

    useEffect(() => {
        if (errorGetCoupons === null) return;
        console.log("errorGetCoupons", errorGetCoupons);
    }, [errorGetCoupons]);

    const requestAxiosRegisterUpdateCoupons = async (type: "register" | "update", value: any) => {
        let response;
        if (type === "register") {
            response = await utilAxiosWithAuth().post(Request.COUPON_URL, value);
        } else {
            response = await utilAxiosWithAuth().put(Request.COUPON_URL + "/" + value.couponId, value);
        }
        return response.data;
    };

    const {
        loading: loadingRegisterUpdateCoupons,
        error: errorRegisterUpdateCoupons,
        data: resultRegisterUpdateCoupons,
        execute: requestRegisterUpdateCoupons,
    } = useAsyncAxios(requestAxiosRegisterUpdateCoupons);

    useEffect(() => {
        if (resultRegisterUpdateCoupons === null) return;
        console.log("resultRegisterUpdateCoupons", resultRegisterUpdateCoupons);

        requestGetCoupons();
    }, [resultRegisterUpdateCoupons]);

    useEffect(() => {
        if (errorRegisterUpdateCoupons === null) return;
        console.log("errorRegisterUpdateCoupons", errorRegisterUpdateCoupons);
    }, [errorRegisterUpdateCoupons]);

    //assign coupon
    const requestAxiosAssignCoupon = async (couponId: number, email: string) => {
        const response = await utilAxiosWithAuth().post(Request.USER_COUPON_ASSIGN_URL, null, {
            params: { couponId: couponId, email: email },
        });
        return response.data;
    };

    const {
        loading: loadingAssignCoupon,
        error: errorAssignCoupon,
        data: resultAssignCoupon,
        execute: requestAssignCoupon,
    } = useAsyncAxios(requestAxiosAssignCoupon);

    useEffect(() => {
        if (resultAssignCoupon === null) return;
        console.log("resultAssignCoupon", resultAssignCoupon);

        requestGetCoupons();
    }, [resultAssignCoupon]);

    useEffect(() => {
        if (errorAssignCoupon === null) return;
        console.log("errorAssignCoupon", errorAssignCoupon);
    }, [errorAssignCoupon]);

    //delete coupon
    const requestAxiosDeleteCoupon = async (coupon: Types.CouponDto) => {
        const response = await utilAxiosWithAuth().delete(Request.COUPON_URL + "/" + coupon.couponId);
        return response.data;
    };

    const {
        loading: loadingDeleteCoupon,
        error: errorDeleteCoupon,
        data: resultDeleteCoupon,
        execute: requestDeleteCoupon,
    } = useAsyncAxios(requestAxiosDeleteCoupon);

    useEffect(() => {
        if (resultDeleteCoupon === null) return;
        console.log("resultDeleteCoupon", resultDeleteCoupon);

        requestGetCoupons();
    }, [resultDeleteCoupon]);

    useEffect(() => {
        if (errorDeleteCoupon === null) return;
        console.log("errorDeleteCoupon", errorDeleteCoupon);
    }, [errorDeleteCoupon]);

    const onAssignCoupon = (coupon: Types.CouponDto) => {
        setCurrentCoupon(coupon);
        setOpenModalAssignCoupon(true);
    };

    const onUpdateCoupon = (coupon: Types.CouponDto) => {
        setCurrentCoupon(coupon);
        setOpenModalCoupon(true);
    };

    const onDeleteCoupon = (coupon: Types.CouponDto) => {
        Modal.confirm({
            title: "쿠폰 삭제",
            content: "쿠폰을 삭제 하시겠습니까?",
            okText: "확인",
            onOk() {
                requestDeleteCoupon(coupon);
            },
            cancelText: "취소",
            onCancel() {},
            centered: true,
        });
    };

    return (
        <div className="container">
            <Space size={30} direction="vertical" style={{ width: "100%" }}>
                <Row align={"middle"} justify={"space-between"}>
                    <h3 className="title">쿠폰 관리</h3>
                    <Button
                        onClick={() => {
                            setOpenModalCoupon(true);
                        }}
                    >
                        {String.userAdd}
                    </Button>
                </Row>
                <Space direction="vertical" size={10} style={{ width: "100%" }}>
                    <DataTable hasScroll={false} columns={columns} rowKey="couponId" dataSource={coupons} canceledRow={disabledCoupons} />
                </Space>
            </Space>
            {openModalCoupon && (
                <ModalCoupon
                    open={openModalCoupon}
                    coupon={currentCoupon}
                    onChangedOpen={(open: boolean) => {
                        setOpenModalCoupon(open);
                        setCurrentCoupon(undefined);
                    }}
                    onChangeCouponInfo={requestRegisterUpdateCoupons}
                />
            )}
            {openModalAssignCoupon && currentCoupon && (
                <ModalAssignCoupon
                    open={openModalAssignCoupon}
                    coupon={currentCoupon}
                    onChangedOpen={(open: boolean) => {
                        setOpenModalAssignCoupon(open);
                        setCurrentCoupon(undefined);
                    }}
                    onAssignCouponInfo={requestAssignCoupon}
                />
            )}
        </div>
    );
}

export default CouponManagement;
